import React, { useEffect, useState } from 'react';
import { Alert, Box, MenuItem, TextField, Typography } from '@mui/material';
import api from '../../../../api/api';

export default function AssetLockerPlacement({ asset, rentalPoints, onChange }) {
  const assetId = asset.id;
  const pointId = asset.rental_point_id || '';
  const cellId = asset.locker_cell_id || '';
  const [cells, setCells] = useState([]);
  const [error, setError] = useState('');
  const point = rentalPoints.find(p => String(p.id) === String(pointId));
  const hasCells = !!point?.has_cells;
  const rented = !!asset.current_deal_id;
  useEffect(() => {
    let active = true; setCells([]); setError('');
    if (pointId && hasCells) api.get(`/locker/points/${pointId}/cells`).then(r => { if (active) setCells(r.data); })
      .catch(() => { if (active) setError('Не удалось загрузить ячейки. Обновите страницу.'); });
    return () => { active = false; };
  }, [pointId, hasCells]);
  return <Box sx={{ p: 2, border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
    <Typography fontWeight={600}>Местонахождение</Typography>
    <TextField select fullWidth margin="dense" label="Пункт проката" value={pointId} disabled={rented}
      onChange={e => {
        const selected = rentalPoints.find(p => String(p.id) === String(e.target.value));
        onChange('rental_point_id', e.target.value);
        onChange('rental_point', selected?.name || '');
        onChange('locker_cell_id', null);
      }}>
      {rentalPoints.map(p => <MenuItem key={p.id} value={p.id}>{p.name}{p.has_cells ? ' · постамат' : ''}</MenuItem>)}
    </TextField>
    {hasCells && <TextField select fullWidth margin="dense" label="Ячейка" value={cellId} disabled={rented}
      onChange={e => onChange('locker_cell_id', e.target.value)} helperText="Выберите свободную ячейку">
      {!!cellId && !cells.some(c => c.id === cellId) && <MenuItem value={cellId} disabled>Текущая ячейка</MenuItem>}
      {cells.map(c => <MenuItem key={c.id} value={c.id} disabled={!!c.operation_id || (!!c.asset && c.asset.id !== assetId)}>
        {c.number} · {c.asset ? c.asset.name : 'свободна'}{c.operation_id ? ' · выполняется операция' : ''}
      </MenuItem>)}
    </TextField>}
    <Typography variant="caption" display="block">ПВЗ и ячейка применятся общей кнопкой «Сохранить». Указывайте место, где вещь находится фактически.</Typography>
    {rented && <Alert severity="info">У клиента / в сделке. Размещение нельзя менять, пока актив в сделке.</Alert>}
    {error && <Alert severity="error">{error}</Alert>}
  </Box>;
}
